// Copyright (c) 2016 Deere & Company

import actions from '../../actions-list';
import {verifyRequiredFields} from '../helpers/verify-required-fields';

export const updateStatusChangeRequestForm = () =>
    (dispatch, getState) =>
        dispatch({
            data: verifyRequiredFields(getState().statusChange.statusChangeRequest),
            type: actions.UPDATE_STATUS_CHANGE_REQUEST_FORM
        });



// WEBPACK FOOTER //
// ./src/product/status-change-request/action-creators/status-change-request-form.js